var BASWebServices;
(function (BASWebServices) {
    var MaintenanceService = (function () {
        function MaintenanceService($http) {
            this.$http = $http;
            this.maintenanceMessage = "";
            this.fillMaintenanceMessageWithFileFromServer(BASWebServices.ConfigService.GET_MAINTENANCE_MESSAGE_URL());
        }
        MaintenanceService.Factory = function ($http) {
            return new MaintenanceService($http);
        };
        MaintenanceService.prototype.fillMaintenanceMessageWithFileFromServer = function (path) {
            this.maintenanceMessage = "";
            this.$http.get(path, {
                _this: this,
                path: path
            })
                .then(function (response) {
                var data = response.data;
                var status = response.status;
                var headers = response.headers;
                var config = response.config;
                var content = data;
                var contentSplit = content.split("\n");
                content = "";
                for (var i = 0; i < contentSplit.length; i++) {
                    if (contentSplit[i].indexOf("#") == 0 || contentSplit[i] == "")
                        continue;
                    else
                        content += contentSplit[i] + "\n";
                }
                config._this.maintenanceMessage = content;
            })
                .catch(function (response) {
                var config = response.config;
                config._this.$scope.WEBSERVICE_VERSION = " N/A ";
                console.error("Could not retrieve WebMAUS version from url " + path);
            });
        };
        MaintenanceService.prototype.getMaintenanceMessage = function () {
            return this.maintenanceMessage;
        };
        return MaintenanceService;
    }());
    BASWebServices.MaintenanceService = MaintenanceService;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=MaintenanceService.js.map